import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "../common/common.css";
import { Toast } from "primereact/toast";
import { setToastRef } from "../utils/toastService";
import { publicRoutes, protectedRoutes } from "../routes/routesConfig";
import ProtectedRoute from "../routes/ProtectedRoute";
import { ConfigProvider } from "antd";
import { antdThemeToken } from "../theme/theme";

const RestrictedRoutes = () => {
  return (
    <ConfigProvider theme={{ token: antdThemeToken }}>
      <Toast ref={setToastRef} />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* Public Routes */}
          {publicRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}

          {/* Protected Routes */}
          {protectedRoutes.map(({ path, Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute>
                  <Component />
                </ProtectedRoute>
              }
            />
          ))}

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </ConfigProvider>
  );
};

export default RestrictedRoutes;
